var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0816 15.1021L9.99999 13.3225L5.91836 15.1021V4.48983H14.0816M14.0816 2.85718H5.91836C5.48535 2.85718 5.07008 3.02919 4.7639 3.33537C4.45772 3.64155 4.28571 4.05682 4.28571 4.48983V17.5511L9.99999 15.1021L15.7143 17.5511V4.48983C15.7143 3.58371 14.9796 2.85718 14.0816 2.85718Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBanner);
export default __webpack_public_path__ + "static/media/icn_banner.c391ff6745068b1d8d0abae456d89075.svg";
export { ForwardRef as ReactComponent };